import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import IndustriesSection from './components/IndustriesSection';
import ApproachSection from './components/ApproachSection';
import TestimonialsSection from './components/TestimonialsSection';
import TeamSection from './components/TeamSection';
import QuoteForm from './components/QuoteForm';
import StructuredData from './components/StructuredData';
import WhatsAppWidget from './components/WhatsAppWidget';
import CarShowroom from './pages/CarShowroom';
import CarDetail from './pages/CarDetail';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import BlogHub from './pages/BlogHub';
import BlogPost from './pages/BlogPost';
import AdminBlog from './pages/AdminBlog';
import FileLibrary from './pages/FileLibrary';
import SourcingPortal from './pages/SourcingPortal';
import ClientAuth from './pages/ClientAuth';
import ClientOrders from './pages/ClientOrders';
import ClientWishlist from './pages/ClientWishlist';
import AgentDashboard from './pages/AgentDashboard';
import { ClientAuthProvider } from './context/ClientAuthContext';
import { isCarsDomain } from './lib/carRoutes';
import CanonicalUrl from './components/CanonicalUrl';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const loginPath = isCarsDomain() ? '/login' : '/cars/login';
  if (loading) return <div className="min-h-screen bg-gray-950 flex items-center justify-center"><div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin"></div></div>;
  if (!user) return <Navigate to={loginPath} replace />;
  return children;
};

const MainSite = () => (
  <div className="App">
    <StructuredData />
    <Header />
    <main>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <IndustriesSection />
      <TestimonialsSection />
      <ApproachSection />
      <TeamSection />
      <QuoteForm />
    </main>
    <Footer />
    <WhatsAppWidget />
  </div>
);

function App() {
  const carsDomain = isCarsDomain();

  return (
    <BrowserRouter>
      <AuthProvider>
        <CanonicalUrl />
        {carsDomain ? (
          /* cars.runtheraysintl.com — Car showroom is the root */
          <Routes>
            <Route path="/" element={<CarShowroom />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/:slug" element={<CarDetail />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        ) : (
          /* runtheraysintl.com / preview — Main site + car routes under /cars */
          <Routes>
            <Route path="/" element={<MainSite />} />
            <Route path="/cars" element={<CarShowroom />} />
            <Route path="/cars/login" element={<AdminLogin />} />
            <Route path="/cars/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/cars/:slug" element={<CarDetail />} />
            <Route path="/blog" element={<BlogHub />} />
            <Route path="/blog/admin" element={<ProtectedRoute><AdminBlog /></ProtectedRoute>} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/downloads" element={<FileLibrary />} />
            <Route path="/sourcing" element={<ClientAuthProvider><SourcingPortal /></ClientAuthProvider>} />
            <Route path="/sourcing/auth" element={<ClientAuthProvider><ClientAuth /></ClientAuthProvider>} />
            <Route path="/sourcing/orders" element={<ClientAuthProvider><ClientOrders /></ClientAuthProvider>} />
            <Route path="/sourcing/wishlist" element={<ClientAuthProvider><ClientWishlist /></ClientAuthProvider>} />
            <Route path="/sourcing/agent" element={<ProtectedRoute><AgentDashboard /></ProtectedRoute>} />
          </Routes>
        )}
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
